import { Text, Spinner } from '@fluentui/react-components';
import { Box, useFluentTokens } from '../../../theme/fluent';

interface WelcomeLoadingScreenProps {
  loadingText: string;
  decorativeImage?: string;
}

export const WelcomeLoadingScreen: React.FC<WelcomeLoadingScreenProps> = ({ loadingText, decorativeImage }) => {
  const { tokens } = useFluentTokens();

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        background: 'linear-gradient(to bottom, #1c3d26, #046a38)',
        padding: '40px 20px',
      }}
    >
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: decorativeImage ? 'clamp(40px, 10vw, 176px)' : '0',
          width: '100%',
          maxWidth: decorativeImage ? '1200px' : '800px',
          flexWrap: decorativeImage ? 'wrap' : 'nowrap',
        }}
      >
        {/* Left content */}
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '45px',
            width: '100%',
            maxWidth: decorativeImage ? '431px' : '584px',
            minWidth: decorativeImage ? '300px' : '0',
            flexShrink: 1,
          }}
        >
          {/* Welcome text section */}
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: tokens.spacingVerticalS,
              color: 'white',
            }}
          >
            <Text
              size={900}
              weight="regular"
              style={{
                display: 'block',
                fontSize: '68px',
                lineHeight: '92px',
                fontWeight: 300,
              }}
            >
              Welcome to
            </Text>
            <Text
              size={900}
              weight="bold"
              style={{
                display: 'block',
                fontSize: '68px',
                lineHeight: '56px',
                fontWeight: tokens.fontWeightBold,
              }}
            >
              Robin
            </Text>
          </Box>

          {/* Spinner with label */}
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: tokens.spacingHorizontalS,
            }}
          >
            <Spinner role={'progressbar'} appearance="inverted" size="medium" aria-label={loadingText} />
            <Text
              size={400}
              weight="semibold"
              style={{
                color: 'white',
                fontSize: tokens.fontSizeBase400,
                lineHeight: tokens.lineHeightBase400,
              }}
            >
              {loadingText}
            </Text>
          </Box>
        </Box>

        {/* Right decorative image (optional) */}
        {decorativeImage && (
          <Box
            style={{
              width: '100%',
              maxWidth: '529px',
              minWidth: '300px',
              aspectRatio: '1',
              flexShrink: 1,
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <img
              src={decorativeImage}
              alt="Decorative pattern"
              aria-hidden="true"
              {...(import.meta.env.VITE_ENVIRONMENT === 'DEV' ? {} : { fetchPriority: 'high' })}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
